<div class="project-list-container">
<div class="h11 d-flex">
    <span class="m-auto">Project
        <span class="highlight">Highlights</span></span>
        <!-- notebook -->
</div>
<div class="project-list">
    <app-project *ngFor="let projectDetails of projectList" [projectDetails]="projectDetails"></app-project>
</div>
</div>